import styled from 'styled-components'

import { theme } from 'styles/theme'

const { media, space, fontSizes, lineHeights, colors, fontWeights, radii } = theme

export const Registration = styled.section`
  width: 100%;
  background-color: ${colors['neutral-background-medium']};
  padding-top: ${space['spacing-xxxl']};
  overflow: hidden;

  @media screen and (${media.tablet}) {
    padding: ${space['spacing-giga']} 0;
    background-color: #01284b;
  }

  & > div {
    position: relative;
    min-height: 500px;
  }
`

export const WrapperRegistration = styled.div`
  position: relative;
  z-index: 1;
`

export const InviteGuardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 calc(-1 * ${space['spacing-md']});
  padding: ${space['spacing-md']};
  background-color: ${colors['neutral-background-default']};

  @media screen and (${media.tablet}) {
    margin: unset;
    border-radius: ${radii['corner-radius-md']};
  }
`

export const WrapperPolygon = styled.div`
  position: absolute;
  top: -30%;
  right: 35%;
  left: 0;

  @media (${media.desktop}) {
    left: 7%;
  }
`

export const TitleWrapper = styled.div`
  h1,
  h1 span {
    font-size: ${fontSizes['font-size-mobile-heading-3']};
    line-height: 1.1em;
  }

  & > p {
    margin-top: ${space['spacing-xl']};
    line-height: ${lineHeights['font-line-height-md']};
  }

  @media (min-width: 800px) {
    z-index: 1;
    position: relative;
  }

  @media (min-width: 800px) and (max-width: 1366px) {
    h1,
    h1 span {
      font-size: ${fontSizes['font-size-heading-1']};
      line-height: 1.1em;
    }

    & > p {
      font-weight: ${fontWeights['font-weight-medium']};
      margin-top: ${space['spacing-xl']};
    }
  }

  @media (min-width: 1370px) {
    h1,
    h1 span {
      font-size: ${fontSizes['font-size-heading-1']};
      line-height: 1.1em;
    }

    & > p {
      font-weight: ${fontWeights['font-weight-medium']};
      margin-top: ${space['spacing-xl']};
    }
  }
`
